import { getCurrentUser } from 'aws-amplify/auth';
import { post } from 'aws-amplify/api';

const AUDIT_TRAIL_KEY = 'virtualis_auth_audit_trail';

function readAuditTrail() {
  try {
    const serializedValue = window.localStorage.getItem(AUDIT_TRAIL_KEY);
    return serializedValue ? JSON.parse(serializedValue) : [];
  } catch (error) {
    return [];
  }
}

function persistAuditTrail(entries) {
  window.localStorage.setItem(AUDIT_TRAIL_KEY, JSON.stringify(entries));
}

function appendAuditTrail(eventType, userId, ip) {
  const auditEntry = {
    userId,
    ip,
    eventType,
    dateTime: new Date().toISOString(),
  };

  const trail = readAuditTrail();
  const nextTrail = [auditEntry, ...trail].slice(0, 25);
  persistAuditTrail(nextTrail);

  return auditEntry;
}

async function getCurrentUserId() {
  try {
    const currentUser = await getCurrentUser();
    return currentUser?.userId || currentUser?.username || 'unknown-user';
  } catch (error) {
    return 'unknown-user';
  }
}

async function resolveClientIp() {
  try {
    const response = await fetch('https://api.ipify.org?format=json', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      return 'unknown-ip';
    }

    const payload = await response.json();
    return payload.ip || 'unknown-ip';
  } catch (error) {
    return 'unknown-ip';
  }
}

export async function recordAuthAuditEntry(eventType) {
  const userId = await getCurrentUserId();
  const ip = await resolveClientIp();
  const auditEntry = appendAuditTrail(eventType, userId, ip);

  try {
    await post({
      apiName: 'portalApi',
      path: '/portalapi/audit',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          eventType,
          userId,
          ip,
          dateTime: auditEntry.dateTime,
        },
      },
    });
  } catch (error) {
    console.error('Could not persist auth audit record.', error);
  }

  return auditEntry;
}

export function readLocalAuditTrail() {
  return readAuditTrail();
}
